<div class="main">
  @for (r of loader.readiness(); track $index) {
    <div [matTooltip]="r"><mat-icon>circle</mat-icon></div>
  } @empty {
    <mat-icon>check</mat-icon>
  }
</div>